// import TimeZoneSelect from '../../Organization/Manager_Dashboard/utils/TimeZoneSelect';
// import TimeInputField from '../../Organization/Manager_Dashboard/utils/TimeInputField';
// import { Edit2, Clock, Monitor } from "lucide-react";
// import ViewTimeZone from '../../Organization/Manager_Dashboard/utils/ViewTimeZone';

// const UpdateUserModal = ({
//     isOpen,
//     user,
//     formData,
//     handleChange,
//     handleSubmit,
//     closeModal,
//     loading,
//     timeZones
// }) => {
//     if (!isOpen || !user) return null;
//     console.log("Update User Model Open:", formData)

//     return (
//         <div
//             className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
//             onClick={closeModal}
//         >
//             <div
//                 className="w-full max-w-2xl border bg-richblue-950 border-blue-700/50 rounded-xl"
//                 onClick={(e) => e.stopPropagation()}
//             >
//                 {/* Header - Compact */}
//                 <div className="px-5 py-3 border-b border-blue-800/40">
//                     <h2 className="flex items-center gap-2 text-xl font-bold text-white">
//                         <Edit2 className="w-5 h-5 text-blue-400" />
//                         Update User
//                     </h2>
//                 </div>

//                 {/* Form - Grid Layout for Compactness */}
//                 <form onSubmit={handleSubmit} className="p-5">
//                     <div className="grid grid-cols-2 gap-4">
//                         {/* Name */}
//                         <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-300">Name</label>
//                             <input 
//                                 type="text" 
//                                 name="user_name" 
//                                 value={formData.user_name} 
//                                 onChange={handleChange}
//                                 className="w-full bg-richblue-900 border border-blue-800/60 rounded-lg px-3 py-1.5 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-700" 
//                                 required 
//                             />
//                         </div>

//                         {/* Email */}
//                         <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-300">Email</label>
//                             <input 
//                                 type="email" 
//                                 name="user_email" 
//                                 value={formData.user_email} 
//                                 onChange={handleChange}
//                                 className="w-full bg-richblue-900 border border-blue-800/60 rounded-lg px-3 py-1.5 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-700" 
//                                 required 
//                             />
//                         </div>

//                         {/* Phone */}
//                         <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-300">Phone</label>
//                             <input 
//                                 type="text" 
//                                 name="user_phone" 
//                                 value={formData.user_phone} 
//                                 onChange={handleChange}
//                                 className="w-full bg-richblue-900 border border-blue-800/60 rounded-lg px-3 py-1.5 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-700" 
//                                 required 
//                             />
//                         </div>

//                         {/* Department */}
//                         <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-300">Department</label>
//                             <input 
//                                 type="text" 
//                                 name="user_department" 
//                                 value={formData.user_department} 
//                                 onChange={handleChange}
//                                 className="w-full bg-richblue-900 border border-blue-800/60 rounded-lg px-3 py-1.5 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-700" 
//                                 required 
//                             />
//                         </div>

//                         {/* Roll Number */}
//                         <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-300">Roll Number</label>
//                             <input 
//                                 type="text" 
//                                 name="user_roll" 
//                                 value={formData.user_roll} 
//                                 onChange={handleChange}
//                                 className="w-full bg-richblue-900 border border-blue-800/60 rounded-lg px-3 py-1.5 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-700" 
//                                 required 
//                             />
//                         </div>

//                         {/* Status */}
//                         <div>
//                             <label className="block mb-1 text-xs font-medium text-blue-300">Status</label>
//                             <select 
//                                 name="status" 
//                                 value={formData.status} 
//                                 onChange={handleChange}
//                                 className="w-full bg-richblue-900 border border-blue-800/60 rounded-lg px-3 py-1.5 text-white text-sm focus:outline-none focus:ring-2 focus:ring-blue-700"
//                             >
//                                 <option value="ACTIVE">Active</option>
//                                 <option value="DEACTIVE">Deactive</option>
//                             </select>
//                         </div>

//                         {/* Shift Start */}
//                         <div>
//                             <TimeInputField
//                                 // icon = {Clock}
//                                 name="shift_start"
//                                 label="Shift Start"
//                                 value={formData.shift_start}
//                                 onChange={handleChange}
//                                 disabled={loading}
//                             />
//                         </div>

//                         {/* Shift End */}
//                         <div>
//                             <TimeInputField
//                                 // icon = {Clock}
//                                 name="shift_end"
//                                 label="Shift End"
//                                 value={formData.shift_end}
//                                 onChange={handleChange}
//                                 disabled={loading}
//                             />
//                         </div>

//                         {/* Time Zone - Full width */}
//                         <div>
//                             <TimeZoneSelect
//                                 formData={formData}
//                                 handleChange={handleChange}
//                                 timeZones={timeZones}
//                                 loading={loading}
//                             />
//                         </div>

//                         <div>
//                             <ViewTimeZone
//                                 formData={formData}
//                                 handleChange={handleChange}
//                                 timeZones={timeZones}
//                                 loading={loading}
//                             />
//                         </div>
//                     </div>

//                     {/* Buttons - Compact */}
//                     <div className="flex gap-3 pt-3 mt-5 border-t border-blue-800/40">
//                         <button 
//                             type="submit" 
//                             className="flex-1 px-4 py-2 text-sm font-medium text-white transition bg-blue-600 rounded-lg hover:bg-blue-700"
//                             disabled={loading}
//                         >
//                             {loading ? "Updating..." : "Update User"}
//                         </button>
//                         <button 
//                             type="button" 
//                             onClick={closeModal} 
//                             className="flex-1 px-4 py-2 text-sm font-medium text-white transition rounded-lg bg-richblue-800 hover:bg-richblue-700"
//                         >
//                             Cancel
//                         </button>
//                     </div>
//                 </form>
//             </div>
//         </div>
//     );
// };

// export default UpdateUserModal;


import TimeZoneSelect from '../../Organization/Manager_Dashboard/utils/TimeZoneSelect';
import TimeInputField from '../../Organization/Manager_Dashboard/utils/TimeInputField';
import { Edit2 } from "lucide-react";
import ViewTimeZone from '../../Organization/Manager_Dashboard/utils/ViewTimeZone';

const UpdateUserModal = ({
    isOpen,
    user,
    formData,
    handleChange,
    handleSubmit,
    closeModal,
    loading,
    timeZones,
    theme
}) => {
    if (!isOpen || !user) return null;
    console.log("Update User Model Open:", formData)

    const isDark = theme === 'dark';

    // Theme-aware classes
    const bgModal = isDark ? 'bg-richblue-950' : 'bg-white';
    const bgHeader = isDark ? 'bg-richblue-950' : 'bg-white';
    const bgInput = isDark ? 'bg-richblue-900' : 'bg-gray-50';
    const bgSelect = isDark ? 'bg-richblue-900' : 'bg-gray-50';
    
    const borderColor = isDark ? 'border-blue-700/50' : 'border-gray-300';
    const borderLight = isDark ? 'border-blue-800/40' : 'border-gray-200';
    const borderInput = isDark ? 'border-blue-800/60' : 'border-gray-300';
    
    const textPrimary = isDark ? 'text-white' : 'text-gray-900';
    const textSecondary = isDark ? 'text-blue-300' : 'text-gray-700';
    //const textMuted = isDark ? 'text-blue-300' : 'text-gray-600';
    const textPlaceholder = isDark ? 'placeholder-blue-400/40' : 'placeholder-gray-400';
    
    //const hoverBg = isDark ? 'hover:bg-blue-600/20' : 'hover:bg-gray-100';
    const buttonSubmit = isDark
        ? 'bg-blue-600 hover:bg-blue-700'
        : 'bg-blue-500 hover:bg-blue-600';
    const buttonCancel = isDark
        ? 'bg-richblue-800 hover:bg-richblue-700'
        : 'bg-gray-200 hover:bg-gray-300';
    const buttonCancelText = isDark ? 'text-white' : 'text-gray-800';

    return (
        <div
            className={`fixed inset-0 z-50 flex items-center justify-center p-4 ${isDark ? 'bg-black/50' : 'bg-gray-500/30'} backdrop-blur-sm`}
            onClick={closeModal}
        >
            <div
                className={`w-full max-w-2xl border ${bgModal} ${borderColor} rounded-xl transition-colors duration-300`}
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header - Compact */}
                <div className={`px-5 py-3 border-b ${bgHeader} ${borderLight}`}>
                    <h2 className={`flex items-center gap-2 text-xl font-bold ${textPrimary}`}>
                        <Edit2 className="w-5 h-5 text-blue-400" />
                        Update User
                    </h2>
                </div>

                {/* Form - Grid Layout for Compactness */}
                <form onSubmit={handleSubmit} className="p-5">
                    <div className="grid grid-cols-2 gap-4">
                        {/* Name */}
                        <div>
                            <label className={`block mb-1 text-xs font-medium ${textSecondary}`}>Name</label>
                            <input 
                                type="text" 
                                name="user_name" 
                                value={formData.user_name} 
                                onChange={handleChange}
                                className={`w-full ${bgInput} border ${borderInput} rounded-lg px-3 py-1.5 ${textPrimary} ${textPlaceholder} text-sm focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
                                required 
                            />
                        </div>

                        {/* Email */}
                        <div>
                            <label className={`block mb-1 text-xs font-medium ${textSecondary}`}>Email</label>
                            <input 
                                type="email" 
                                name="user_email" 
                                value={formData.user_email} 
                                onChange={handleChange}
                                className={`w-full ${bgInput} border ${borderInput} rounded-lg px-3 py-1.5 ${textPrimary} ${textPlaceholder} text-sm focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
                                required 
                            />
                        </div>

                        {/* Phone */}
                        <div>
                            <label className={`block mb-1 text-xs font-medium ${textSecondary}`}>Phone</label>
                            <input 
                                type="text" 
                                name="user_phone" 
                                value={formData.user_phone} 
                                onChange={handleChange}
                                className={`w-full ${bgInput} border ${borderInput} rounded-lg px-3 py-1.5 ${textPrimary} ${textPlaceholder} text-sm focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
                                required 
                            />
                        </div>

                        {/* Department */}
                        <div>
                            <label className={`block mb-1 text-xs font-medium ${textSecondary}`}>Department</label>
                            <input 
                                type="text" 
                                name="user_department" 
                                value={formData.user_department} 
                                onChange={handleChange}
                                className={`w-full ${bgInput} border ${borderInput} rounded-lg px-3 py-1.5 ${textPrimary} ${textPlaceholder} text-sm focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
                                required 
                            />
                        </div>

                        {/* Roll Number */}
                        <div>
                            <label className={`block mb-1 text-xs font-medium ${textSecondary}`}>Roll Number</label>
                            <input 
                                type="text" 
                                name="user_roll" 
                                value={formData.user_roll} 
                                onChange={handleChange}
                                className={`w-full ${bgInput} border ${borderInput} rounded-lg px-3 py-1.5 ${textPrimary} ${textPlaceholder} text-sm focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
                                required 
                            />
                        </div>

                        {/* Status */}
                        <div>
                            <label className={`block mb-1 text-xs font-medium ${textSecondary}`}>Status</label>
                            <select 
                                name="status" 
                                value={formData.status} 
                                onChange={handleChange}
                                className={`w-full ${bgSelect} border ${borderInput} rounded-lg px-3 py-1.5 ${textPrimary} text-sm focus:outline-none focus:ring-2 focus:ring-blue-700 transition-colors duration-300`}
                            >
                                <option value="ACTIVE">Active</option>
                                <option value="DEACTIVE">Deactive</option>
                            </select>
                        </div>

                        {/* Shift Start */}
                        <div>
                            <TimeInputField
                                name="shift_start"
                                label="Shift Start"
                                value={formData.shift_start}
                                onChange={handleChange}
                                disabled={loading}
                                theme={theme}
                            />
                        </div>

                        {/* Shift End */}
                        <div>
                            <TimeInputField
                                name="shift_end"
                                label="Shift End"
                                value={formData.shift_end}
                                onChange={handleChange}
                                disabled={loading}
                                theme={theme}
                            />
                        </div>

                        {/* Time Zone - Full width */}
                        <div>
                            <TimeZoneSelect
                                formData={formData}
                                handleChange={handleChange}
                                timeZones={timeZones}
                                loading={loading}
                                theme={theme}
                            />
                        </div>

                        <div>
                            <ViewTimeZone
                                formData={formData}
                                handleChange={handleChange}
                                timeZones={timeZones}
                                loading={loading}
                                theme={theme}
                            />
                        </div>
                    </div>

                    {/* Buttons - Compact */}
                    <div className={`flex gap-3 pt-3 mt-5 border-t ${borderLight}`}>
                        <button 
                            type="submit" 
                            className={`flex-1 px-4 py-2 text-sm font-medium text-white transition ${buttonSubmit} rounded-lg disabled:opacity-50`}
                            disabled={loading}
                        >
                            {loading ? "Updating..." : "Update User"}
                        </button>
                        <button 
                            type="button" 
                            onClick={closeModal} 
                            className={`flex-1 px-4 py-2 text-sm font-medium transition rounded-lg ${buttonCancel} ${buttonCancelText}`}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdateUserModal;
